<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/gccOrderStatistics";

export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => t.key !== "statType")
    );
  },
  data() {
    return {
      methods: {
        ...apis,
        list(p) {
          return apis.province(p);
        },
        beforeHandleList({ data }) {
          return data;
        }
      },
      config: {
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            },
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("省份"),
          key: "province",
          minWidth: 110
        },
        {
          name: () => this.$tz("入库数量"),
          key: "inbound_num",
          minWidth: 110
        },
        {
          name: () => this.$tz("签收,数量"),
          key: "pod_num",
          minWidth: 110
        },
        {
          name: () => this.$tz("单量,占比"),
          key: "rate",
          minWidth: 110
        },
        {
          name: () => this.$tz("签收率"),
          key: "pod_rate",
          minWidth: 110
        }
      ]
    };
  }
};
</script>

<style scoped></style>
